module.exports = __webpack_public_path__ + "media/mypage/images/flat/thinking-b73260d53f2a23e05061944874cca330.png";